import { DropdownItem } from "../types";

export const COUNTRIES: DropdownItem[] = [
  { key: "United States", value: "US" },
  { key: "Canada", value: "CA" },
];
